import { CreateButton, List } from "@refinedev/antd";

import { AwardsList } from "./Awards-List";

export const AwardsPage = () => {
  return (
    <List
      title="Награды"
      resource={"awards"}
      breadcrumb={false}
      canCreate={false}
      wrapperProps={{ style: { position: "sticky", top: 24 } }}
      headerButtons={
        <CreateButton resource={"awards"}>Добавить награду</CreateButton>
      }
    >
      <AwardsList />
    </List>
  );
};
